import Vue from 'vue';
import store from './../../store';

/**
 * Clear local state and redirect to login
 */
const clearLocalState = () => {
  store.dispatch('logout');
  Vue.router.push({
    name: 'auth.login',
  });
};

export default () => {
  // Call backend logout endpoint to fire logout event
  // Even if this fails (e.g., token expired, network error), we still clear local state
  Vue.$http.post('/auth/logout')
    .then(() => {
      clearLocalState();
    })
    .catch(() => {
      // Silently handle errors - always clear local state
      // Token might already be invalid/expired, so backend call may fail
      clearLocalState();
    });
};



// WEBPACK FOOTER //
// ./src/app/services/auth/logout.js